import React from 'react'
import { getUtms, change } from '../../../store/actions/metrics.action'
import { Button, CircularProgress, TextField, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import { FcFilingCabinet} from 'react-icons/fc'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaShoppingCart, FaUser } from 'react-icons/fa'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreen, changeScreenB } from '../../../store/actions/navigation.action'
import VerifySms from '../../components/VerifySms'

export default function Metrics(props) {
    const dispatch = useDispatch()
    const campaign_id = (props.uid) ? props.uid : null;
    const link_id = (props.link_id) ? props.link_id : null;

    const { open, screen_id } = useSelector(state => state.smsReducer)
    const { utms } = useSelector(state => state.metricsReducer)

    const [isLoad, setLoad] = React.useState(true)
    const [isLoading, setLoading] = React.useState(true)
    const date = new Date();
    const dateInit = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T00:00'
    const dateEnd = new Intl.DateTimeFormat('pt-BR', {year: 'numeric'}).format(new Date(date))+'-'+ new Intl.DateTimeFormat('pt-BR', {month: '2-digit'}).format(new Date(date)) +'-'+new Intl.DateTimeFormat('pt-BR', {day: '2-digit'}).format(new Date(date))+'T23:59'

    const [dateInitial, setDateInitial] = React.useState(null)
    const [dateFinal, setDateFinal] = React.useState(null)
    const [periodo, setPeriodo] = React.useState('today')
    const [source, setSource] = React.useState('utm_source')

    React.useEffect(() => {
        return () => {
            dispatch(change('clear'))
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    React.useEffect(() => {
        _index(periodo)
    }, [dateInitial, dateFinal, source])

    const _index = async (periodo) => {
        setLoad(true)
      
        const initial = dateInitial ? new Date(dateInitial) : null;
        const final = dateFinal ? new Date(dateFinal) : null;
      
        await dispatch(getUtms(campaign_id, link_id, source, periodo, initial, final))
      
        setLoad(false)
        setLoading(false)
    }

    const handlePeriodo = (value) => {
        if (periodo !== value) {
            setDateInitial(null)
            setDateFinal(null)
            setPeriodo(value)
            _index(value)
        }
    }

    const getUtmValue = (item, type) => {
        switch (type) {
          case 'utm_source':
            return item.utm_source
          case 'utm_content':
            return item.utm_content
          case 'utm_campaign':
            return item.utm_campaign
          case 'utm_medium':
            return item.utm_medium
          default:
            return '-'
        }
    }

    return (
        <>
            <VerifySms 
                type="login_code"
                open={screen_id === 'metrics.utms' && open}
                onConfirm={() => {
                    _index()
                }}
                onClose={() => window.location.replace('/')}
            />
            <div className="app-bar">
                <AppBar position="fixed">
                    <Toolbar>
                        <IconButton onClick={() => link_id ? dispatch(changeScreenB({ open: false })) : dispatch(changeScreen({ open: false })) } edge="start" color="inherit">
                            <MdKeyboardBackspace />
                        </IconButton>
                        <Typography variant="h6">
                            UTMs
                        </Typography>
                    </Toolbar>
                </AppBar>
                
                {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                <div className="card p-3 mt-3 mb-2 bs-bg">
                    <h6 className="bs-color-b mb-3">Filtros por Período</h6>

                    <div className="row mb-3">
                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (periodo === 'today' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => handlePeriodo('today')}
                            >
                                HOJE
                            </Button>
                        </div>

                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (periodo === 'week' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => handlePeriodo('week')}
                            >
                                Semana
                            </Button>
                        </div>

                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (periodo === 'month' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => handlePeriodo('month')}
                            >
                                Mês
                            </Button>
                        </div>

                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (periodo === 'geral' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => handlePeriodo('geral')}
                            >
                                Geral
                            </Button>
                        </div>
                    </div>

                    <div className="row mt-2 mb-3">
                        <div className="col-6">
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateInitial))}&nbsp;&nbsp;&nbsp;
                                    {(dateInitial) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateInitial))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    label="Data Inicial"
                                    type="datetime-local"
                                    value={dateInitial}
                                    defaultValue={dateInit}
                                    InputLabelProps={{
                                        shrink: dateInitial ? true : false,
                                    }}
                                    onBlur={e => {
                                        setPeriodo(null)
                                        if(e.target.value) {
                                            setDateInitial(e.target.value)
                                        } else {
                                            setDateInitial(dateInit)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="col-6">
                            <div className="date">
                                <label className="label-date bs-color-b">
                                    {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {year: 'numeric', month: '2-digit',day: '2-digit'}).format(new Date(dateFinal))}&nbsp;&nbsp;&nbsp;
                                    {(dateFinal) && new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(dateFinal))}    
                                </label>
                                <TextField
                                    id="datetime-local"
                                    label="Data Final"
                                    type="datetime-local"
                                    value={dateFinal}
                                    defaultValue={dateEnd}
                                    InputLabelProps={{
                                        shrink: dateFinal ? true : false,
                                    }}
                                    onBlur={e => {
                                        setPeriodo(null)
                                        if(e.target.value) {
                                            setDateFinal(e.target.value)
                                        } else {
                                            setDateFinal(dateEnd)
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <h6 className="bs-color-b mb-3">UTMs</h6>
                    <div className="row mb-3">
                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (source === 'utm_source' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => setSource('utm_source')}
                            >
                                Source
                            </Button>
                        </div>

                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (source === 'utm_campaign' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => setSource('utm_campaign')}
                            >
                                Campaign
                            </Button>
                        </div>

                        <div className="col">
                            <Button
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (source === 'utm_medium' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => setSource('utm_medium')}
                            >
                                Medium
                            </Button>
                        </div>

                        <div className="col">
                            <Button 
                                fullWidth 
                                className={"bs-bg-invert bs-color-b "+ (source === 'utm_content' && 'btn-checked')}
                                variant="contained" 
                                color="primary" 
                                size="small"
                                onClick={() => setSource('utm_content')}
                            >
                                Content
                            </Button>
                        </div>
                    </div>
                </div>
                
                {(isLoad) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                    <>
                        
                        <div className="card p-3 mt-3 mb-2 bs-bg">
                            {(utms.length < 1) &&
                                <div className="card-body bs-bg mt-3">
                                    <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                        <FcFilingCabinet size="70" />
                                        <h6 className="mt-4 text-muted bs-color">Nenhum registro cadastrado</h6>
                                    </div>
                                </div>
                            }
                            
                            {(utms.length > 0) &&
                                <div className="table-responsive">
                                    <table className="table">
                                        <tbody>
                                            <tr>
                                                <td className="bs-color-b ps-0">{source}</td>
                                                <td className="bs-color-b text-center"><FaShoppingCart /></td>
                                                <td className="bs-color-b text-center"><FaUser /></td>
                                                <td className="bs-color-b text-center">Afiliado</td>
                                                <td className="bs-color-b text-end">Total</td>
                                            </tr>
                                            {utms.map((item, index) => (
                                                <tr key={index}>
                                                    <td className="bs-color-b ps-0" scope="row">{getUtmValue(item, source)}</td>
                                                    <td className="bs-color-b text-center">
                                                        {item.total_transaction?.toLocaleString('pt-BR', { style: 'decimal' }) || 0}
                                                    </td>
                                                    <td className="bs-color-b text-center">
                                                        {item.total_user?.toLocaleString('pt-BR', { style: 'decimal' }) || 0}
                                                    </td>
                                                    <td className="bs-color-b text-center fw-bold">
                                                        {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.total_liquid || 0)}
                                                    </td>
                                                    <td className="bs-color-b text-end fw-bold">
                                                        {new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(item.total_amount || 0)}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            }
                        </div>
                    </>
                }
                </>
                }
            </div>
        </>
    )
}